/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Subtitle_KbInputs */

const en_signin_subtitle_kb = /** @type {(inputs: Signin_Subtitle_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One workspace for your human and AI teammates.`)
};

const id_signin_subtitle_kb = /** @type {(inputs: Signin_Subtitle_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu papan kerja untuk tim manusia dan agen AI-mu.`)
};

/**
* | output |
* | --- |
* | "One workspace for your human and AI teammates." |
*
* @param {Signin_Subtitle_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_subtitle_kb = /** @type {((inputs?: Signin_Subtitle_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Subtitle_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_subtitle_kb(inputs)
	return en_signin_subtitle_kb(inputs)
});